import React, { useContext, useEffect, useState } from "react";
import {
  CButton,
  CCard,
  CCardHeader,
  CCol,
  CRow,
  CModal,
  CModalHeader,
  CModalBody,
  CModalFooter,
  CModalTitle,
  CTableRow,
  CTableHeaderCell,
  CTable,
  CTableBody,
  CTableDataCell,
  CBadge,
  CCardBody,
  CTableHead,
  CImage,
  CSpinner,
  CFormText,
} from "@coreui/react";

// Add this new component above your main Visitations component
function VisitationSummary({ data, loading }) {
  if (loading || !data || data.length === 0) {
    return (
      <CCard className="mb-4">
        <CCardHeader>
          <CRow className="align-items-center">
            <CCol>
              <h5>Summary</h5>
            </CCol>
          </CRow>
        </CCardHeader>
        <CCardBody>
          {loading ? (
            <div className="text-center">
              <CSpinner size="sm" />
              <span className="ml-2">Loading summary...</span>
            </div>
          ) : (
            <div className="text-muted">No data available</div>
          )}
        </CCardBody>
      </CCard>
    );
  }

  // Calculate metrics
  const totalVisits = data.length;
  const totalDuration = data.reduce((sum, visit) => sum + (visit.duration || 0), 0);
  const avgDuration = totalVisits > 0 ? Math.round(totalDuration / totalVisits) : 0;

  const visitsByVisibility = data.reduce((acc, visit) => {
    const visibility = visit.visibility || "Unknown";
    acc[visibility] = (acc[visibility] || 0) + 1;
    return acc;
  }, {});

  const mostCommonVisibility = Object.entries(visitsByVisibility).sort((a, b) => b[1] - a[1])[0]?.[0] || "None";

  const visitsBySales = data.reduce((acc, visit) => {
    const sales = visit.userName || "Unknown";
    acc[sales] = (acc[sales] || 0) + 1;
    return acc;
  }, {});

  const topSales = Object.entries(visitsBySales).sort((a, b) => b[1] - a[1])[0]?.[0] || "None";

  return (
    <CCard className="mb-4">
      <CCardHeader>
        <CRow className="align-items-center">
          <CCol>
            <h5>Summary </h5>
            <CFormText> *(berdasarkan filter tanggal & SMD)</CFormText>
          </CCol>
        </CRow>
      </CCardHeader>
      <CCardBody>
        <CRow>
          <CCol sm={6} lg={3}>
            <div className="border-start border-start-4 border-start-info px-3 mb-3">
              <div className="text-medium-emphasis small">Total Visits</div>
              <div className="fs-5 fw-semibold">{totalVisits}</div>
            </div>
          </CCol>

          <CCol sm={6} lg={3}>
            <div className="border-start border-start-4 border-start-success px-3 mb-3">
              <div className="text-medium-emphasis small">Avg Duration</div>
              <div className="fs-5 fw-semibold">{avgDuration} mins</div>
            </div>
          </CCol>

          <CCol sm={6} lg={3}>
            <div className="border-start border-start-4 border-start-warning px-3 mb-3">
              <div className="text-medium-emphasis small">Most Common Visibility</div>
              <div className="fs-5 fw-semibold">{mostCommonVisibility}</div>
            </div>
          </CCol>

          <CCol sm={6} lg={3}>
            <div className="border-start border-start-4 border-start-danger px-3 mb-3">
              <div className="text-medium-emphasis small">Top Salesperson</div>
              <div className="fs-5 fw-semibold">{topSales}</div>
            </div>
          </CCol>
        </CRow>

        {/* Additional insights row */}
        <CRow className="mt-3">
          <CCol sm={6} lg={3}>
            <div className="border-start border-start-4 border-start-primary px-3 mb-3">
              <div className="text-medium-emphasis small">Total Duration</div>
              <div className="fs-5 fw-semibold">{totalDuration} mins</div>
            </div>
          </CCol>

          <CCol sm={6} lg={3}>
            <div className="border-start border-start-4 border-start-secondary px-3 mb-3">
              <div className="text-medium-emphasis small">Unique Stores</div>
              <div className="fs-5 fw-semibold">{new Set(data.map((v) => v.storeName)).size}</div>
            </div>
          </CCol>

          <CCol sm={6} lg={3}>
            <div className="border-start border-start-4 border-start-dark px-3 mb-3">
              <div className="text-medium-emphasis small">Completed Visits</div>
              <div className="fs-5 fw-semibold">{data.filter((v) => v.checkOut !== "Belum").length}</div>
            </div>
          </CCol>

          <CCol sm={6} lg={3}>
            <div className="border-start border-start-4 border-start-light px-3 mb-3">
              <div className="text-medium-emphasis small">Pending Visits</div>
              <div className="fs-5 fw-semibold">{data.filter((v) => v.checkOut === "Belum").length}</div>
            </div>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>
  );
}

export default VisitationSummary;
